import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule, Location } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { portalVersion } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/auth.service';
import { SidebarService } from '../../core/services/sidebar.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TranslateModule],
  providers: [TranslateService],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  portalVersion = portalVersion.version;

  userData = JSON.parse(localStorage.getItem('userData') || '{}');

  userName = this.userData.firstName;

  sidebarCollapsed = false;

  activeRoute = '';

  constructor(
    private router: Router,
    private location: Location,
    private sidebarService: SidebarService,
    private authService: AuthService,
  ) {
    // Subscribe to sidebar state changes
    this.sidebarService.sidebarState$.subscribe((state) => {
      this.sidebarCollapsed = state;
    });
  }

  // Toggle Sidebar Collapse
  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    this.sidebarService.toggleSidebar();
  }

  // Check if the current page is the signIn page
  isLoginPage(): boolean {
    return this.router.url === '' || this.router.url === '/signIn';
  }

  // Set Active Route on component initialization
  ngOnInit(): void {
    this.setActiveRoute();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd)) // Listen for route changes
      .subscribe((event: NavigationEnd) => {
        this.sidebarService.setActiveRoute(event.urlAfterRedirects); // Update route in SidebarService
        this.activeRoute = event.urlAfterRedirects; // Track the active route
      });
  }

  // Set initial active route when component loads
  setActiveRoute(): void {
    const currentPath = this.location.path();
    this.activeRoute = currentPath || '/dashboard';
  }

  // Check if a sidebar item is active
  isActive(route: string): boolean {
    return this.router.url.startsWith(route);
  }

  logout() {
    this.authService.logout();
  }
}
